export default "__VITE_ASSET__CQD9Ncft__"